export var scriptTag = function scriptTag() {
  return document.createElement('script');
};
export function newHeadScript(content, options, onload) {
  var script = scriptTag();
  if (content) script.text = content;
  Object.assign(script, options);
  if (onload) script.onload = onload;
  document.head.appendChild(script);
  return script;
}
export function normalizeData(data) {
  var normalized = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) normalized[key] = data[key];
  });
  return normalized;
}